import { render } from "./StoreProductBroadwise.vue?vue&type=template&id=1aea4a4b&scoped=true"
import script from "./StoreProductBroadwise.vue?vue&type=script&lang=js"
export * from "./StoreProductBroadwise.vue?vue&type=script&lang=js"

import "./StoreProductBroadwise.vue?vue&type=style&index=0&id=1aea4a4b&lang=scss&scoped=true"

import exportComponent from "F:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aea4a4b"]])

export default __exports__